export const NotificationCampaignsEnum = {
    BIRTHDAY : "BIRTHDAY",
    VISANA_GAMEDAY :"VISANA_GAMEDAY",
    NO_SHOW :"NO_SHOW",
    GAMEDAY :"GAMEDAY",
};
